import React, { useState, useRef, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { FaRegClock, FaRegCalendarAlt } from 'react-icons/fa';
import { IoChevronBack } from 'react-icons/io5';
import { BsFillPlayCircleFill, BsFillPauseCircleFill } from 'react-icons/bs';
import { useNoobookContext } from '../context/NoobookContext';
import { putMyBookRecord, getTotalRecordInSec, getMyBookByBookId } from '../api/BookcaseApi';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import { getDday, formatTime, getTimeDiff, stringFrDate } from '../common/utils';
import { ownership2text, RecordType } from '../common/enums'; 
import LoadingOverlay from '../components/LoadingOverlay';
import { ErrorContainer, ErrorMessage } from '../components/ErrorContainer';
import { set } from 'lodash';
import BookCoverImage from '../components/BookCoverImage';


const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 80vh;
  background: #eae8e9;
`;

const BookInfoContainer = styled.div`
  padding: 0 0 0 0;
  background: #eae8e9;
`;

/*
const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
`;

const BookInfoBox = styled.div`
  padding: 0 0 0 0;
  background: #eae8e9;
`;
const BookInfoRow = styled.div`
  display: flex;
  gap: 10px;
  padding: 20px 0 0px 0px;
`;
*/
const BookInfoRow = styled.div`
  display: flex;
  gap: 16px;
  padding: 40px 10px 20px 10px;
`;

const BookInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Dday = styled.div`
  background: #636363;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  padding: 2px 4px;
  margin-left: 0;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;
const Title = styled.div`
  font-size: 17px;
  font-weight: 500;
  color: #222;
  margin-left: 8px;
  display: inline-block;
`;
const Author = styled.div`
  font-size: 15px;
  color: #888;
  margin-bottom: 4px;
  margin-left: 8px;
`;
const Period = styled.div`
  font-size: 13px;
  color: #888;
  margin-left: 7px;
  padding-bottom: 10px;
`;
const Badge = styled.span`
  background: #1976d2;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;
const IconRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 32px;
  justify-content: center;
`;
const IconBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #555;
  font-size: 14px;
`;

const SeparatorBar = styled.div`
  width: 100%;
  max-width: 440px;
  height: 12px;
  background: #eae8e9;
  border-radius: 4px;
  border-top: 1px solid #fff;
  box-shadow: 0 4px 16px rgba(0,0,0,0.18);
  margin: -6px auto 32px auto;
`;

const TimerSection = styled.div`
  background: #eae8e9 !important;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 12px 0 0 0;
`;
const TimerCircle = styled.div`
  width: 260px;
  height: 260px;
  border-radius: 50%;
  border: 7px solid #d2d2d2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #eae8e9;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
`;
const TimerState = styled.div`
  color: #888;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
`;
const TimerValue = styled.div`
  font-size: 48px;
  font-weight: 700;
  color: #252525;
  margin-bottom: 8px;
`;
const TotalLabel = styled.div`
  color: #888;
  font-size: 16px;
  margin-bottom: 2px;
`;
const TotalValue = styled.div`
  color: #707070;
  font-size: 22px;
  font-weight: 600;
`;
const TimerButton = styled.button`
  margin-top: 16px;
  margin-bottom: 48px;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MainContainer = styled.div`
  background: #eae8e9;
  min-height: 100vh;
`;

const BookInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 56%;
`;

const BookTitleRow = styled.div`
  font-size: 17px;
  font-weight: 500;
  color: #222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
  margin-left: 0;
  min-width: 0;
  padding-left: 0;
  display: flex;
  align-items: center;
`;

const DdayBadge = styled.div`
  background: #636363;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  padding: 2px 4px;
  margin-left: 0;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;

const BookTitle = styled.span`
  margin-left: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
`;

const BookAuthor = styled.div`
  font-size: 15px;
  color: #888;
  margin-bottom: 4px;
  margin-left: 8px;
`;

const BookPeriod = styled.div`
  font-size: 13px;
  color: #888;
  margin-left: 7px;
  padding-bottom: 10px;
`;

const BookBadge = styled.span`
  background: #1976d2;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 32px;
  justify-content: center;
`;

const ActionButton = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #555;
  font-size: 14px;
`;
/*
function formatTime(sec) {
  //console.log("sec", sec);
  const m = String(Math.floor(sec / 60)).padStart(2, '0');
  const s = String(sec % 60).padStart(2, '0');
  return `${m}:${s}`;
}

function getTimeDiff(startAt, endAt) {
  if(!startAt || !endAt || startAt > endAt) {
    return 0;
  }
  return Math.floor((endAt.getTime() - startAt.getTime()) / 1000);
}
*/

export default function BookTimerPage({propPageTimerType, propBookId, onClose}) {
  const { showBack, setShowBack, setTimerStartAt, setTimerEndAt, setTimerBookId, setTimerType, timerStartAt, timerEndAt, timerBookId, timerType } = useNoobookContext();
  const [isRunning, setIsRunning] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bookData, setBookData] = useState(null);
  const [total, setTotal] = useState(0); // 누적 시간(초)
  //const [startAt, setStartAt] = useState(null);
  //const [endAt, setEndAt] = useState(null);
  const [error, setError] = useState(null);
  const intervalRef = useRef(null);
  const confirmShownRef = useRef(false); // confirm 중복 호출 방지용 플래그
  const navigate = useNavigate();

  const {pageTimerType:argPageTimerType, bookId:argBookId} = useParams();

  const [pageTimerType, setPageTimerType] = useState(propPageTimerType ? propPageTimerType : argPageTimerType);
  const [bookId, setBookId] = useState(propBookId ? propBookId : argBookId);


  // React Router의 useBlocker를 사용하여 네비게이션 감지
  // blocker 상태 감지 및 처리
 // useEffect(() => {
  //  const handleBeforeUnload = (e) => {
   //   if (isRunning && startAt && endAt && startAt < endAt) {
    //    e.preventDefault();
    //    e.returnValue = '타이머가 동작 중입니다. 기록을 저장하시겠습니까?';
     //   return '타이머가 동작 중입니다. 기록을 저장하시겠습니까?';
   //   }
    //};

    // 페이지 새로고침 또는 탭 닫기 감지
    //window.addEventListener('beforeunload', handleBeforeUnload);

    //return () => {
    //  window.removeEventListener('beforeunload', handleBeforeUnload);
    //};
  //}, [isRunning, startAt, endAt]);
  

  React.useEffect(() => {
    //console.log("1.timerBookId", timerBookId);
    //console.log("1.bookId", bookId);
    //console.log("1.timerType", timerType);
    //console.log("1.pageTimerType", pageTimerType);
    //console.log("1.timerStartAt", timerStartAt);
    //console.log("1.timerEndAt", timerEndAt);
    //console.log("1.timerStartAt < timerEndAt", timerStartAt < timerEndAt);
    if(timerBookId == bookId && timerType == pageTimerType && timerStartAt && timerEndAt && timerStartAt < timerEndAt) {
      setTimerEndAt(new Date());
      setIsRunning(true);
    } else if ((timerBookId != bookId || timerType != pageTimerType) && timerStartAt && timerEndAt && timerStartAt < timerEndAt && !confirmShownRef.current) {
      confirmShownRef.current = true; // confirm 표시 플래그 설정
      const confirmed = window.confirm('다른 타이머가 동작 중입니다. 이전 타이머를 중단하고 기록을 저장하시겠습니까?');
      if (confirmed) {
        //await saveRecord();
        saveRecord().then(() => {
        // 저장 완료 후 뒤로가기 허용
        }).catch(() => {
        // 저장 실패 시 현재 페이지 유지
        }).finally(() => {
          //confirmShownRef.current = false; // 플래그 리셋
        });
      } else {
        if(onClose) {
          onClose();
        } else {
          navigate(-1);
        }
        confirmShownRef.current = true; // 플래그 리셋
        //window.history.back();
      }   
  //   }, 1000);
    }
    const prevShowBack = showBack;
      setShowBack(true);
      return () => {
        setShowBack(prevShowBack);
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          console.log("unmountclearInterval ");
        }
        console.log("unmountclearInterval ", timerType, timerBookId);
      };
  }, []);

  // 독서 기록 저장 함수
  const saveRecord = async () => {

   // console.log("saveRecord timerStartAt", timerStartAt);
    //console.log("saveRecord timerEndAt", timerEndAt);
    //console.log("saveRecord timerBookId", timerBookId);
    //console.log("saveRecord timerType", timerType);
    //console.log("saveRecord timerStartAt >= timerEndAt", timerStartAt >= timerEndAt);
    if (!timerStartAt || !timerEndAt || !timerBookId || !timerType || timerStartAt >= timerEndAt) { 
      return; 
    }
    console.log("saveRecord 2 timerStartAt < timerEndAt", timerStartAt < timerEndAt);
    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      
      // 독서 기록 저장
      const recordResponse = await putMyBookRecord(accessToken || '', timerBookId, (timerType == 'read' ? RecordType.READING : RecordType.SCRIPTING), timerStartAt, new Date());
      const processedRecordResponse = processApiResponse(recordResponse);
      
      if (!processedRecordResponse.success) {
        console.error('독서 기록 저장 실패:', processedRecordResponse.errorMessage);
        setError(processedRecordResponse.errorMessage);
        return;
      }

      setTimerStartAt(null);
      setTimerEndAt(null);
      setTimerBookId(null);
      setTimerType(null);
      
      // 총 독서 시간 조회
      const totalResponse = await getTotalRecordInSec(accessToken || '', bookId, (pageTimerType == 'read' ? RecordType.READING : RecordType.SCRIPTING));
      const processedTotalResponse = processApiResponse(totalResponse);
      
      if (processedTotalResponse.success) {
        setTotal(processedTotalResponse.data || 0);
      } else {
        console.error('총 독서 시간 조회 실패:', processedTotalResponse.errorMessage);
        setError(processedTotalResponse.errorMessage);
      }
      
    } catch (error) {
      console.error('API 호출 중 오류:', error);
      setError('네트워크 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const timerCallback = useCallback(() => {
    //if(!timerStartAt) {
    //  setTimerStartAt(new Date());
    //  setTimerBookId(parseInt(bookId));
    //  setTimerType('read');
    //}
    setTimerEndAt(new Date());
    //setEndAt(new Date());
    //console.log("2.timerBookId", timerBookId);
    //console.log("2.timerType", timerType);
    //console.log("2.pageTimerType", pageTimerType);
    //console.log("2.bookId", bookId);
    //console.log("2.timerStartAt", timerStartAt);
    //console.log("2.timerEndAt", timerEndAt);
    //console.log("endAt", endAt);
    //console.log("startAt.getTime()", startAt.getTime());
  }, [timerStartAt, timerEndAt, timerBookId, timerType]);




  const startTimer = () => {
    if(!timerStartAt) {
      setTimerStartAt(new Date());
    }
    console.log("3.bookId", bookId);
    console.log("3.pageTimerType", pageTimerType);
    console.log("3.propBookId", propBookId);
    console.log("3.propPageTimerType", propPageTimerType);
    setTimerBookId(bookId);
    setTimerType(pageTimerType);
    setTimerEndAt(timerStartAt);
    if(intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    intervalRef.current = setInterval(timerCallback, 1000);
  }
  // 타이머 동작
  React.useEffect(() => {
    if (isRunning) {
      
      if((timerType != pageTimerType || timerBookId != bookId )&& timerStartAt && timerEndAt && timerStartAt < timerEndAt) {
        /*const confirmed = window.confirm('이전 타이머가 동작 중입니다. 이전 기록을 저장하시겠습니까?');
        if (confirmed) {
          //await saveRecord();
          saveRecord().then(() => {
            // 저장 완료 후 뒤로가기 허용
          }).catch(() => {
            // 저장 실패 시 현재 페이지 유지
          }).finally(() => {
            setTimerStartAt(new Date());
            startTimer();
          });
        } else {
          startTimer();
        }*/
      } else {
        startTimer();
      }
      
      /*else  if(!timerStartAt) {
        setTimerStartAt(new Date());
      }
      setTimerBookId(parseInt(bookId));
      setTimerType('read');
      setTimerEndAt(timerStartAt);
      intervalRef.current = setInterval(() => {
        setTimerEndAt(new Date());
        console.log("timerStartAt", timerStartAt);
        console.log("timerEndAt", timerEndAt);
        //console.log("startAt.getTime()", startAt.getTime());
      }, 1000); */
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current);
      console.log("clearInterval");
      intervalRef.current = null;
      setTimerEndAt(new Date());
      if (timerStartAt && timerEndAt && timerStartAt < timerEndAt) {
        saveRecord();
      }
    }
    
  }, [isRunning]);

  // 뒤로가기 감지 및 확인 메시지
  /*useEffect(() => {
    const handlePopState = (event) => {
      if (isRunning && startAt && endAt && startAt < endAt) {
        event.preventDefault();
        const confirmed = window.confirm('타이머가 동작 중입니다. 기록을 저장하시겠습니까?');
        if (confirmed) {
          saveRecord().then(() => {
            // 저장 완료 후 뒤로가기 허용
            window.history.back();
          }).catch(() => {
            // 저장 실패 시 현재 페이지 유지
            window.history.pushState({ timerRunning: true }, '', window.location.href);
          });
        } else {
          // 저장하지 않고 뒤로가기 허용
          window.history.back();
        }
      }
    };

    //window.addEventListener('popstate', handlePopState);
    
    return () => {
      //window.removeEventListener('popstate', handlePopState);
    };
  }, [isRunning, startAt, endAt]);*/

  // 일시정지 시 누적
  /*useEffect(() => {
    console.log("isRunning", isRunning);
    if (!isRunning && startAt && endAt && startAt < endAt) {
      saveRecord();
    }
    // eslint-disable-next-line
  }, [isRunning]);*/

  // 컴포넌트 마운트 시 총 독서 시간 로드
 useEffect(() => {
    const loadInitialData = async () => {
      if (!bookId) return;
      setLoading(true);
      try {

        const { accessToken } = await getAccessToken();
        const totalResponse = await getTotalRecordInSec(accessToken || '', bookId, (pageTimerType == 'read' ? RecordType.READING : RecordType.SCRIPTING));
        const processedTotalResponse = processApiResponse(totalResponse);
        
        if (processedTotalResponse.success) {
          setTotal(processedTotalResponse.data || 0);
        }

        const bookResponse = await getMyBookByBookId(accessToken || '', bookId);
        const processedBookResponse = processApiResponse(bookResponse);
        
        if (processedBookResponse.success) {
          setBookData(processedBookResponse.data);
        } else {
          setError(processedBookResponse.errorMessage);
          return;
        }

      } catch (error) {
        console.error('총 독서 시간 로드 중 오류:', error);
        setError('네트워크 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    };
    
    loadInitialData();
  }, [bookId]);


  if (error || !bookData) {
    return (
      <ErrorContainer>
        <ErrorMessage>{error || '책 정보를 찾을 수 없습니다.'}</ErrorMessage>
      </ErrorContainer>
    );
  }

  // API 데이터를 기존 sampleBookData 형식으로 변환
  const transformedData = {
    id: bookData.id,
    title: bookData.title,
    author: bookData.author + ' / ' + bookData.publisher,
    //period: (pageTimerType == 'read' ? (bookData?.readFr??'') + ' ~ ' + (bookData?.readTo??'') : (bookData?.scriptFr??'') + ' ~ ' + (bookData?.scriptTo??'')),
    period: stringFrDate(pageTimerType == 'read' ? bookData.readFr : bookData.scriptFr, 'yyyy-MM-dd', '-') + ' ~ ' + stringFrDate(pageTimerType == 'read' ? bookData.readTo : bookData.scriptTo, 'yyyy-MM-dd', '-'),
    dday: getDday(pageTimerType == 'read' ? bookData.readTo : bookData.scriptTo),
    badge: ownership2text(bookData.ownership),
    cover: bookData.cover,
    progress: (!bookData.pageNum || bookData.pageNum == 0) ? '-' : Math.round(100 * ((pageTimerType == 'read' ? bookData.readPage : bookData.scriptPage) / bookData.pageNum))
  };




  return (
    <>
      
        <PageWrapper>
          <BookInfoContainer>
            <BookInfoRow>
              <BookCoverImage
                src={transformedData.cover}
                alt={transformedData.title}
              />
              <BookInfoContent>
                <BookTitleRow>
                  <DdayBadge>{transformedData.dday}</DdayBadge>
                  &nbsp;<BookTitle>{transformedData.title}</BookTitle>
                </BookTitleRow>
                <BookAuthor>
                  {transformedData.author}
                </BookAuthor>
                <BookPeriod>
                  {transformedData.period}
                </BookPeriod>
                <div>
                  <BookBadge>{transformedData.badge}</BookBadge>
                </div>
              </BookInfoContent>
            </BookInfoRow>
          </BookInfoContainer>
          <SeparatorBar />
          <TimerSection>
            <TimerCircle>
              <TimerState>{isRunning ? (pageTimerType == 'read' ? '읽는 중' : '필사 중') : '일시정지'}</TimerState>
              <TimerValue>{formatTime(getTimeDiff(timerStartAt, timerEndAt))}</TimerValue>
              <TotalLabel>{pageTimerType == 'read' ? '총 독서 시간' : '총 필사 시간'}</TotalLabel>
              <TotalValue>{formatTime(total)}</TotalValue>
            </TimerCircle>
            <TimerButton onClick={() => setIsRunning((v) => !v)}>
              {isRunning ? (
                <BsFillPauseCircleFill size={56} color="#bdbdbd" />
              ) : (
                <BsFillPlayCircleFill size={56} color="#244ac2" />
              )}
            </TimerButton>
          </TimerSection>
        </PageWrapper>
      
      {loading && <LoadingOverlay />}
    </>
  );
} 